import { NavController } from '@ionic/angular'
import { AlertService } from '../../services/alert/alert.service'
import { UserService } from '../../services/user/user.service'
import { FormGroup } from '@angular/forms'
import { Component } from '@angular/core'

@Component({
  selector: 'app-forgotpw',
  templateUrl: './forgotpw.page.html',
  styleUrls: ['./forgotpw.page.scss'],
})
export class ForgotpwPage {

  constructor(
    private userService: UserService,
    private alert: AlertService,
    private navCtrl: NavController
  ) { }

  forgotpw(form: FormGroup) {
    this.userService.forgotpw(form.value.email)
      .then(() => this.alert.toast(`Eine Nachricht wurde an die angegebene E-Mail-Adresse <b>${form.value.email}</b> gesendet`, 10))
      .then(() => this.navCtrl.pop())
      .catch((err) => this.alert.errorHandler(err, true))
  }

}
